<template>
  <div class="wrap" :class="{ fixedTop: true }">
    <div 
      class="bar" 
      @mouseenter="barHoverFlag = true"
      @mouseleave="barHoverFlag = false"
    >
      <router-link to="/" class="logo-box" >
        <img src="../../assets/yylogo1.png" alt="医影智能logo">
      </router-link>

      <div class="nav-group">
        <span class="nav-link"><router-link to="/">首页</router-link></span>
        <span class="nav-link"><router-link to="/medical">产品中心</router-link></span>
        <span class="nav-link" @click="toNews"><router-link to="/news">新闻资讯</router-link></span>
        <span class="nav-link"><router-link to="/people">人才招聘</router-link></span>
        <span class="nav-link"><router-link to="/about">关于我们</router-link></span>
        <span class="nav-link"><router-link to="/contact">联系我们</router-link></span>
      </div>

      <div class="search-wrap">
        <input 
          v-model="searchVal" 
          type="text" 
          placeholder="请输入搜索内容"
          class="search-input"
          @keyup.enter="handleSearch"
        >
        <button class="search-btn" @click="handleSearch">搜索</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      barHoverFlag: false,
      searchVal: ''
    }
  },
  mounted() {
    // 只保留路由监听，删除滚动监听、联系栏高度、transform偏移逻辑
    this.$watch('$route.path', () => this.barHoverFlag = false)
  },
  beforeDestroy() {
    // 移除滚动事件销毁（已不再监听scroll）
  },
  methods:{
    toProduct(){
      this.$store.commit('toTab/change_atN','vr')
    },
    toNews(){
      sessionStorage.removeItem("store")
      this.$store.commit('news/change_ifShowA',true)
      this.$store.commit('news/change_ifShowB',false)
    },
    handleSearch() {
      const keyword = this.searchVal.trim()
      if (!keyword) {
        alert('请输入搜索内容');
        return
      }
      this.$router.push({
        path: '/search',
        query: {
          key: keyword
        }
      })
      this.searchVal = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap{
  width: 100%;
  height: clamp(60px, 5vw, 90px);
  background: #2563AF;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
/* 永久显示阴影，固定置顶样式 */
.wrap.fixedTop {
  box-shadow: 0 2px 12px rgba(0,0,0,0.12);
}

.bar{
  width: 80%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  gap: 4%;

  .logo-box {
    flex: 0 0 14%;
    min-width: 160px;
    img{
      width: 100%;
      height: auto;
      display: block;
      object-fit: contain;
    }
  }

  .nav-group {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5vw;
  }

  .nav-link{
    font-size: clamp(14px, 1.1vw, 20px);
    font-weight: bold;
    color: #fff;
    white-space: nowrap;
    a{
      color: #ffffff;
      transition: color 0.3s ease;
      &.router-link-exact-active{
        color: #90CDFF;
      }
      &:hover {
        color: #90CDFF;
      }
    }
  }

  .search-wrap {
    flex: 0 0 18%;
    min-width: 220px;
    display: flex;
    align-items: center;
    gap: 1vw;

    .search-input {
      flex: 1;
      height: clamp(30px, 2.2vw, 36px);
      line-height: 1;
      padding: 0 1em;
      border-radius: 999px;
      border: 1px solid rgba(255,255,255,0.6);
      background: rgba(255,255,255,0.18);
      color: #fff;
      outline: none;
      font-size: clamp(12px, 0.85vw, 14px);
      &::placeholder {
        color: rgba(255,255,255,0.7);
      }
      &:focus {
        background: rgba(255,255,255,0.25);
        border-color: #90CDFF;
      }
    }
    .search-btn {
      height: clamp(30px, 2.2vw, 36px);
      padding: 0 1.4em;
      border-radius: 999px;
      border: none;
      background: #90CDFF;
      color: #2563AF;
      font-weight: bold;
      font-size: clamp(12px, 0.85vw, 14px);
      cursor: pointer;
      transition: background 0.2s ease;
      white-space: nowrap;
      &:hover {
        background: #b8e0ff;
      }
    }
  }
}
</style>